import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { Login } from "./components/Login";
import { Shell } from "./components/Shell";
import "./styles.css";

function Root() {
  const { authenticated, loading } = useAuth();
  if (loading) return <div className="login"><div className="card">…</div></div>;
  return authenticated ? <Shell /> : <Login />;
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
